import React, { useContext, useRef } from 'react';
import './ModuleDetailModal.css';
import TabPanel from '../NewTabPanel/NewTabPanel'
import Panel from '../NewTabPanel/NewPanel'
import GroupMultiSelect from '../GroupMultiSelect/GroupMultiSelect';
import Toggle from '../Toggle/Toggle';
import ActionButtons from '../ActionButtons/ActionButtons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StaffCheckInSettings from '../StaffCheckInSettings/StaffCheckInSettings';
import ModuleDetailModalAvailabilityContent from './ModuleDetailModalAvailabilityContent';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { ModuleAdminContext } from '../../contexts/ModuleAdminContext';
import { AdminContext } from '../../contexts/AdminContext';
import groupTypes from '../../common/groupTypes';
import logComponent from '../../common/logComponent';

export default function ModuleDetailModalContent(
  {
    currentPanel,
    toggleGroupTypePermissions,
    toggleFacilityEnabledStatus,
    toggleCorporationEnabledStatus,
    toggleFamilyEnabledStatus,
    enabledForFamily,
    enabledForFacility,
    enabledForCorporation,
    groupsLoading,
    groupsError,
    validateField,
    startModalExit,
    handleStaffCheckNoteChange,
    updateModule
  }) {
  const environmentContext = useContext(EnvironmentContext);
  const adminContext = useContext(AdminContext);
  const moduleAdminContext = useContext(ModuleAdminContext);
  const { activeUser: user } = environmentContext;
  const { module,
    initialGroupTypePermissions,
    currentGroupTypePermissions,
    groupTypePermissionsLoading,
    groupTypePermissionsError,
    initialGroupPermissions,
    groupPermissionsLoading,
    groupPermissionsError,
    updateStatus } = moduleAdminContext;
  const { groups } = adminContext;
  const actionButtons = useRef(null);

  if (logComponent('ModuleDetailModalContent')) { console.debug('ModuleDetailModalContent render'); }

  const getModuleAvailability = () => {
    if (logComponent('ModuleDetailModalContent')) { console.debug('ModuleDetailModalContent getModuleAvailability'); }
    if (!initialGroupTypePermissions) return;

    return (
      <ul className="Module-Detail-Modal__availability-summary">
        <li key="corporateStaff" className="Module-Detail-Modal__availability-summary-item">
          <FontAwesomeIcon
            icon={initialGroupTypePermissions.includes(2) ? 'user-check' : 'user-slash'}
            className={initialGroupTypePermissions.includes(2) ? 'Module-Detail-Modal__available-icon' : 'Module-Detail-Modal__unavailable-icon'} />
          Corporate staff
        </li>
        <li key="facilityStaff" className="Module-Detail-Modal__availability-summary-item">
          <FontAwesomeIcon
            icon={initialGroupTypePermissions.includes(3) ? 'user-check' : 'user-slash'}
            className={initialGroupTypePermissions.includes(3) ? 'Module-Detail-Modal__available-icon' : 'Module-Detail-Modal__unavailable-icon'} />
          Facility staff
        </li>
        <li key="familyStaff" className="Module-Detail-Modal__availability-summary-item">
          <FontAwesomeIcon
            icon={initialGroupTypePermissions.includes(4) ? 'user-check' : 'user-slash'}
            className={initialGroupTypePermissions.includes(4) ? 'Module-Detail-Modal__available-icon' : 'Module-Detail-Modal__unavailable-icon'} />
          Family members
        </li>
      </ul>
    );
  }


  const getServiceIcon = (isUsingService) => {
    if (logComponent('ModuleDetailModalContent')) { console.debug('ModuleDetailModalContent getServiceIcon'); }
    if (isUsingService) {
      return <FontAwesomeIcon icon="check-circle" className="Module-Detail-Modal__active-service" />;
    } else {
      return <FontAwesomeIcon icon="times-circle" className="Module-Detail-Modal__inactive-service" />;
    }
  }


  return (module && initialGroupTypePermissions && currentGroupTypePermissions && initialGroupPermissions &&

    <div className="Module-Detail-Modal">
      <h3 className="Module-Detail-Modal__heading">Module management</h3>
      <p className={'Module-Detail-Modal__page-error' + (updateStatus === 'failure' ? ' visible' : '')}>Sorry, we were unable to complete the action.  Changes were not saved.  Please try again.</p>
      <p className={'Module-Detail-Modal__page-error' + (module.facilityStatus === 'Not Available' ? ' visible' : '')}>This module is not available right now</p>
      {
        module.facilityStatus === 'Not Available' &&
        <React.Fragment>
          <div className="Module-Detail-Modal__not-available">
            <p className="Module-Detail-Modal__not-available-message">This module is not available because it requires integration with the following products:</p>
            <ul className="Module-Detail-Modal__required-products-list">
              {
                module.catieDependent &&
                <li>
                  <span>CATIE</span><p></p>
                  <a href="http://www.statussolutions.com/technologies/self-service" target="_blank" rel="noopener noreferrer">Learn more about CATIE</a>
                </li>
              }
              {
                module.saraDependent &&
                <li>SARA
                  <a href="http://www.statussolutions.com/technologies/automated-alerting" target="_blank" rel="noopener noreferrer">Learn more about SARA</a>
                </li>
              }
              {
                module.eMessengerDependent &&
                <li>eMessenger
                  <a href="http://www.statussolutions.com/casestudies/view/37/305" target="_blank" rel="noopener noreferrer">Learn more about eMessenger</a>
                </li>
              }
            </ul>
          </div>
          <p className="Module-Detail-Modal__info-list-heading">Module information</p>
        </React.Fragment>
      }



      <dl className="Module-Detail-Modal__info-list">
        <dt>Module name</dt>
        <dd>{module.name}</dd>
        <dt>Description</dt>
        <dd>{module.description}</dd>
        {
          module.facilityStatus !== 'Not Available' &&
          <React.Fragment>
            <dt>Dependencies</dt>
            <dd>
              <p>This module depends on the following other products:</p>
              <ul className="Module-Detail-Modal__dependency-list">
                <li key="catieDependency" className="Module-Detail-Modal__dependency">{getServiceIcon(module.catieDependent)}CATIE</li>
                <li key="saraDependency" className="Module-Detail-Modal__dependency">{getServiceIcon(module.saraDependent)}SARA</li>
                <li key="eMessengerDependency" className="Module-Detail-Modal__dependency">{getServiceIcon(module.eMessengerDependent)}eMessenger</li>
              </ul>
            </dd>
          </React.Fragment>
        }
      </dl>

      {
        module.facilityStatus !== 'Not Available' &&
        <React.Fragment>
          <TabPanel
            className="Module-Detail-Modal__tab-panel"
            tabClass="tab"
            showPanel={currentPanel}
            selectedTabClass="tab--selected"
            separatorClass="separator"
            panelClass="panel">
            <Panel
              title="Availability"
              hideIf={user.groupTypeString !== 'Status Solutions'}>
              <ModuleDetailModalAvailabilityContent
                groupTypes={groupTypes}
                groupTypePermissionsLoading={groupTypePermissionsLoading}
                groupTypePermissionsError={groupTypePermissionsError}
                currentGroupTypePermissions={currentGroupTypePermissions}
                toggleGroupTypePermissions={toggleGroupTypePermissions}
              />
            </Panel>
            <Panel title="Assignment" >
              {
                user.groupTypeString === 'Facility' &&
                <dl className="Module-Detail-Modal__assignment-list">
                  {
                    currentGroupTypePermissions &&
                    currentGroupTypePermissions.includes(4) &&
                    <React.Fragment>
                      <dt>Family Members</dt>
                      <dd>
                        <p>Select whether or not this module is visible to family members.</p>
                        <div className="Module-Detail-Modal__enabled-toggle">
                          <Toggle
                            selected={enabledForFamily}
                            toggleValue={toggleFamilyEnabledStatus}
                            showTextValue={true}
                            trueText="Enabled"
                            falseText="Disabled"
                          />
                        </div>
                      </dd>
                    </React.Fragment>
                  }
                  {
                    currentGroupTypePermissions &&
                    currentGroupTypePermissions.includes(3) &&
                    <React.Fragment>
                      <dt>Facility Staff</dt>
                      <dd>
                        <p>Select whether or not this module is available to facility staff. Once enabled, access may be granted via group assignment.</p>
                        <div className="Module-Detail-Modal__enabled-toggle">
                          <Toggle
                            selected={enabledForFacility}
                            toggleValue={toggleFacilityEnabledStatus}
                            showTextValue={true}
                            trueText="Enabled"
                            falseText="Disabled"
                          />
                        </div>
                      </dd>
                    </React.Fragment>
                  }
                </dl>
              }
              {
                user.groupTypeString === 'Corporate' &&
                currentGroupTypePermissions &&
                currentGroupTypePermissions.includes(2) &&
                <dl className="Module-Detail-Modal__assignment-list">
                  <dt>Corporate Users</dt>
                  <dd>
                    <p>Select whether or not this module is available to users of your corporation.</p>
                    <div className="Module-Detail-Modal__enabled-toggle">
                      <Toggle
                        selected={enabledForCorporation}
                        toggleValue={toggleCorporationEnabledStatus}
                        showTextValue={true}
                        trueText="Enabled"
                        falseText="Disabled"
                          />
                    </div>
                  </dd>
                </dl>
              }

              {
                ((user.groupTypeString === 'Status Solutions') || (user.groupTypeString === 'Corporate' && enabledForCorporation) || (user.groupTypeString === 'Facility' && enabledForFacility)) && groups && initialGroupPermissions && !groupPermissionsLoading && !groupPermissionsError &&
                <React.Fragment>
                  {
                    user.groupTypeString === 'Status Solutions' ?
                      <p>Select which groups should have access to this module.  This applies only to Status Solutions users.</p> :
                      <p>Select which groups at your organization should have access to this module.</p>
                  }
                  <GroupMultiSelect
                    label=""
                    name="groups"
                    selectedGroupIds={initialGroupPermissions}
                    selectedGroupIdsError={groupPermissionsError}
                    selectedGroupIdsLoading={groupPermissionsLoading}
                    allGroups={groups}
                    groupsLoading={groupsLoading}
                    groupsError={groupsError}
                    onValidate={validateField}
                  />
                </React.Fragment>
              }
              <p className="Module-Detail-Modal__availability-summary-instruction"><span className="bold">Note:</span> This module has limited availability based on user type:</p>
              {getModuleAvailability()}

            </Panel>
            <Panel title="Settings">
              {
                module.name === 'Staff Check-in' && user.groupTypeString === 'Facility' ?
                  <div className="Module-Detail-Modal__settings-list">
                    <StaffCheckInSettings
                      onChange={handleStaffCheckNoteChange} />
                  </div> :
                  <div>
                    <FontAwesomeIcon icon="cogs" className="Module-Detail-Modal__settings-none-icon" />
                    <span>No settings available for this module</span>
                  </div>
              }
            </Panel>
          </TabPanel>
          <ActionButtons
            ref={actionButtons}
            mainAction={updateModule}
            mainActionText="Save changes"
            cancel={startModalExit}
            cancelText="Cancel"
            currentStatus={updateStatus} />
        </React.Fragment>
      }
      {
        module.facilityStatus === 'Not Available' &&
        <React.Fragment>
          <p className="Module-Detail-Modal__availability-summary-instruction">This module is designed for the following types of users:</p>
          {getModuleAvailability()}
          <ActionButtons
            ref={actionButtons}
            cancel={startModalExit}
            cancelText="OK" />
        </React.Fragment>
      }
    </div>
  );
}

